"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var shutdown_monitor_1 = __importDefault(require("./shutdown_monitor"));
var shutdownMonitor = new shutdown_monitor_1.default();
function default_1() {
    return {
        load: function (client) {
            shutdownMonitor.setClient(client);
            // at the moment, the shutdown monitor only sends events from the queue
            // if we implement a queue for throttling errors, we won't have to check for `config.eventsEnabled`
            if (client.config.eventsEnabled) {
                shutdownMonitor.maybeAddListener();
            }
            else {
                shutdownMonitor.maybeRemoveListener();
            }
        },
        shouldReloadOnConfigure: true,
    };
}
exports.default = default_1;
//# sourceMappingURL=shutdown_plugin.js.map